import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-gender-picker-modal',
  templateUrl: './gender-picker-modal.component.html',
  styleUrls: ['./gender-picker-modal.component.scss'],
  standalone: false
})
export class GenderPickerModalComponent {
  @Input() initialGender: string = '';

  selectedGender: string = '';

  constructor(private modalCtrl: ModalController) { }

  ionViewWillEnter() {
    this.selectedGender = this.initialGender || '';
  }

  confirm() {
    this.modalCtrl.dismiss(this.selectedGender);
  }

  select(gender: string) {
    this.selectedGender = gender;
    this.confirm();
  }

}
